import { ArrowForward } from '@mui/icons-material';
import { FormControl, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { PasswordInput } from '../../../../components/HookFormFields/PasswordInput';
import OutlinedTextField from '../../../../components/HookFormFields/TextField';
import { PATHS } from '../../../../config/consts';
import { RouterLink } from '../../../ResetPasswordPage/components/Link/PrimaryLink';
import { useLoginFlowButtons } from '../../hook/useLoginFlowButtons';
import messages from '../../messages';
import { Animation } from './Animation';

const PasswordFieldHeight = 103;

export interface IAuthLoginFormData {
  isSubmitDisabled: boolean;
  isSSOLogin: boolean;
}

export function AuthLoginForm({ isSSOLogin, isSubmitDisabled }: IAuthLoginFormData) {
  const { buttonsDirection, buttonsSpacing } = useLoginFlowButtons();

  return (
    <FormControl fullWidth>
      <OutlinedTextField
        id="username-input"
        label={<FormattedMessage {...messages.authLoginEmailLabel} />}
        name="email"
        required
        autoFocus
        type="email"
        hasTopAndBottomMargin
      />

      <Animation isChildVisible={!isSSOLogin} height={PasswordFieldHeight}>
        <PasswordInput
          id="password-input"
          label={<FormattedMessage {...messages.authLoginPasswordLabel} />}
          name="password"
          required
          type="password"
          sx={{ width: '100%' }}
        />
      </Animation>

      <Stack
        direction={buttonsDirection}
        spacing={buttonsSpacing}
        justifyContent={'space-between'}
        alignItems="center"
        mt={3}
      >
        <Animation isChildVisible={!isSSOLogin}>
          <RouterLink to={PATHS.PASSWORD_RESET}>
            <span data-testid="forgotten-password-link">
              <FormattedMessage {...messages.authLoginForgottenPassword} />
            </span>
          </RouterLink>
        </Animation>

        <Button
          startIcon={<ArrowForward />}
          color="primary"
          disabled={isSubmitDisabled}
          id="login-button"
          size="large"
          type="submit"
          variant="contained"
        >
          {isSSOLogin ? 'Log in WITH SSO' : <FormattedMessage {...messages.authLoginSubmit} />}
        </Button>
      </Stack>
    </FormControl>
  );
}
